import { render, staticRenderFns } from "./WaitingList.vue?vue&type=template&id=ec2ed5b6&scoped=true"
import script from "./WaitingList.vue?vue&type=script&lang=ts"
export * from "./WaitingList.vue?vue&type=script&lang=ts"
import style0 from "./WaitingList.vue?vue&type=style&index=0&id=ec2ed5b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2ed5b6",
  null
  
)

export default component.exports